import { c as _c } from "react/compiler-runtime";
import { Card } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { ReportSectionHeader } from '@/features/investigation';
import { conditionText, type ReportSection, sectionTitle } from './report-outline';
import SectionExample from './section-example';
type ReaderViewProps = {
  sections: ReportSection[];
};
const ReaderView = t0 => {
  const $ = _c(13);
  const {
    sections
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.report"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <p className="px-1 text-body-2 text-primary">{t2}</p>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== sections || $[6] !== t) {
    let t5;
    if ($[8] !== t) {
      t5 = section => <Card.Root key={section.id}><ReportSectionHeader rightContent={section.when ? t(_temp2, {
          condition: conditionText(section.when)
        }) : undefined} title={sectionTitle(section)} />{section.kind === "narrative" || section.kind === "custom" ? <Card.Body className="p-4 md:p-5"><SectionExample kind="narrative" />{section.kind === "custom" && <p className="mt-3 text-caption-2 text-tertiary">{t(_temp3)}</p>}</Card.Body> : <SectionExample kind={section.kind} />}</Card.Root>;
      $[8] = t;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t4 = sections.map(t5);
    $[5] = sections;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <article className="flex flex-col gap-4 pb-4">{t3}{t4}</article>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default ReaderView;
function _temp($) {
  return $.samplePreview;
}
function _temp2($_0) {
  return $_0.conditionSummary;
}
function _temp3($_1) {
  return $_1.customPreviewNote;
}